import { useState } from 'react';
import { AuthModal, type AuthView } from './AuthModal';
import { AuthShell } from './AuthShell';

/**
 * `?action=` picks the first view, so forgedash.uk can link straight to the
 * right one: "Start free" → `?action=signup`, "Sign in" → `?action=signin`.
 * Anything else — including no parameter, which is how the installed PWA
 * opens — keeps the long-standing default of Create account.
 */
function initialView(): AuthView {
    const action = new URLSearchParams(window.location.search).get('action');
    return action === 'signin' || action === 'login' ? 'signin' : 'signup';
}

/**
 * Keep the address bar in step with the view, so a refresh or a shared link
 * lands on the same screen. Only `action` changes — an invite token, a
 * partner `?ref=` or anything else in the URL is left exactly as it arrived.
 */
function rememberView(view: AuthView) {
    const url = new URL(window.location.href);
    url.searchParams.set('action', view);
    window.history.replaceState(window.history.state, '', url);
}

/**
 * Unauthenticated entry. Option B = no intermediate "command centre" gate:
 * the on-brand auth form IS the screen. AuthModal renders inline and is not
 * dismissible here; on auth success the session change re-renders App and
 * this unmounts. Create account / Sign in switch in place, and invite tokens
 * are auto-detected.
 */
export function LoginScreen() {
    const [defaultView] = useState(initialView);
    return (
        <AuthShell>
            <AuthModal isOpen onClose={() => { }} dismissible={false} defaultView={defaultView} onViewChange={rememberView} />
        </AuthShell>
    );
}
